import { StaticInterface } from '../../../helpers/static-interface';
import EmblaCarousel from 'embla-carousel';
import ClassNames from "embla-carousel-class-names";

export interface ITpxShowcase {
  loadEmbla(parentEl: HTMLElement): void;
}

export interface IStaticShowcaseUtils {
  new (...args: any[]): ITpxShowcase;
  init(): void;
}

/**
 * Knowledge Hero utilities
 * @class
 */
export default class TpxShowcaseUtils
  implements StaticInterface<IStaticShowcaseUtils, typeof TpxShowcaseUtils>
{
  constructor(element: HTMLElement) {
    this.loadEmbla(element);
  }

  /**
   * Load Embla
   */
  loadEmbla(parentEl: HTMLElement): void {
  
    if (!parentEl) return;
    
    const carousel = {
      options: {
        loop: false,
        slidesToScroll: 1,
        inViewThreshold: 1,
        draggable: true,
        align: 0,
      },
      components: {
        componentEl: parentEl,
        containerEl: <HTMLElement | null>parentEl.querySelector('[data-component="CarouselContainer"]'),
        buttonEls: <NodeList>parentEl.querySelectorAll('[data-component="Button"]'),
        prevButton: <HTMLElement>parentEl.querySelectorAll('[data-component="Button"]')[0],
        nextButton: <HTMLElement>parentEl.querySelectorAll('[data-component="Button"]')[1]
      }
    }

    if (!carousel.components.containerEl) return;

    const embla = EmblaCarousel(carousel.components.containerEl, carousel.options);
    const prevButton = carousel.components.prevButton;
    const nextButton = carousel.components.nextButton;

    const setupPrevNextBtns = (prevButton, nextButton, embla) => {
      prevButton.addEventListener('click', embla.scrollPrev, false);
      nextButton.addEventListener('click', embla.scrollNext, false);
    };

    setupPrevNextBtns(prevButton, nextButton, embla);

    // Set first active button
    carousel.components.prevButton.classList.add('is-selected');
    
    
  }

  /**
   * Create new instances of TpxShowcase for each element with class o-further-reading"
   */
  static init(scope?: HTMLElement) {
    [
      ...(scope || document).querySelectorAll('[data-component="Showcase"]'),
    ].forEach((elem) => {
      new TpxShowcaseUtils(elem as HTMLElement);
    });
  }
}
